import { cx } from '@emotion/css'
import { AppState, capitalize, ScriptLoadResult } from '@news-mono/web-common'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { TaboolaProps } from './Taboola'
import { StyledTaboolaContainer } from './Taboola.styled'
import { TaboolaContext } from './TaboolaScriptProvider'

export const Taboola: React.FC<TaboolaProps> = ({
    articleId,
    locationType,
    taboolaContainerId,
    isFourColumns,
}) => {
    const { result } = useContext(TaboolaContext)
    const renditionType = useSelector(
        (state: AppState) => state.render.renditionType,
    )

    const taboolaMode =
        renditionType === 'app'
            ? 'alternating-thumbnails-a-app'
            : 'alternating-thumbnails-a'

    const placementType =
        `Below ${capitalize(locationType)} Thumbnails` +
        (isFourColumns ? ' Wide' : '')

    React.useEffect(() => {
        if (result === ScriptLoadResult.Success) {
            // TODO Fix type error here
            window._taboola.push({
                [locationType]: 'auto',
                url: window.location.href,
            } as any)

            window._taboola.push({
                mode: taboolaMode,
                container: taboolaContainerId,
                placement: placementType,
                target_type: 'mix',
            })
        }
    }, [result, articleId, taboolaContainerId, locationType, taboolaMode])

    return (
        <StyledTaboolaContainer
            id={taboolaContainerId}
            className={cx('hide-print')}
        ></StyledTaboolaContainer>
    )
}
Taboola.displayName = 'Taboola'

export default Taboola
